import React from "react";
import MyBet from "../../casinoComponents/myBet";

/** Pair Plus payouts shown by the reference RightSideBar (from its casino/rules API) for 20-20 Teenpatti. */
const PAIR_PLUS_RULES = [
  ["Pair", "1 TO 1"],
  ["Flush", "1 TO 4"],
  ["Straight", "1 TO 6"],
  ["Trio", "1 TO 30"],
  ["Straight Flush", "1 TO 40"],
];

// Reference markup: .card.m-b-10 > .card-header > h6.card-title.d-inline-block "Rules"
//   + .card-body(padding 10px) > table.table.table-bordered.rules-table
export function Teen20RulesCard({ rules = PAIR_PLUS_RULES, heading = "Pair Plus" }) {
  return (
    <div className="card m-b-10">
      <div className="card-header">
        <h6 className="card-title d-inline-block">{"\n          Rules\n          "}</h6>
      </div>{" "}
      <div className="card-body" style={{ padding: "10px" }}>
        <table className="table table-bordered rules-table">
          <tbody>
            <tr className="text-center">
              <th colSpan={2}>{heading}</th>
            </tr>
            {rules.map(([nat, val]) => (
              <tr key={nat}>
                <td width="60%">{nat}</td>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/** Right sidebar for the 20-20 Teenpatti casino pages: My Bets + Rules card (reference RightSideBar). */
export default function Teen20RightSide({ bets, onViewMore, rules }) {
  return (
    <>
      <MyBet bets={bets} onViewMore={onViewMore} />{" "}
      <Teen20RulesCard rules={rules} />
    </>
  );
}
